import {
  BUSINESS_DETAILS_CONSTANTS,
  INCIDENT_DETAILS_CONSTANTS,
  SHIPMENT_DETAILS_CONSTANTS,
  CLAIM_DETAILS_CONSTANTS,
  FILE_ATTACHMENTS_CONSTANTS,
} from "../../forms/Cargo/constants";
import { REVIEW_PAGE_CONSTANTS } from "../../forms/constants";

import * as BusinessDetails from "../../forms/Cargo/Stage1/BusinessDetails";
import * as IncidentDetails from "../../forms/Cargo/Stage1/IncidentDetails";
import * as ShipmentDetails from "../../forms/Cargo/Stage1/ShipmentDetails";
import * as ClaimDetails from "../../forms/Cargo/Stage2/ClaimDetails";
import * as FileAttachments from "../../forms/Cargo/Stage3/FileAttachments";

import { cloneDeep } from "lodash";
import { FormValidationType } from "../../forms/types";
import { CARGO_STAGES } from "./types";

export const CARGO_STEP_NAMES = {
  [CARGO_STAGES.STAGE1]: [
    BUSINESS_DETAILS_CONSTANTS.FORM_NAME,
    SHIPMENT_DETAILS_CONSTANTS.FORM_NAME,
    INCIDENT_DETAILS_CONSTANTS.FORM_NAME,
    REVIEW_PAGE_CONSTANTS.FORM_NAME,
  ],

  [CARGO_STAGES.STAGE2]: [
    CLAIM_DETAILS_CONSTANTS.FORM_NAME,
    REVIEW_PAGE_CONSTANTS.FORM_NAME,
  ],
  [CARGO_STAGES.STAGE3]: [
    FILE_ATTACHMENTS_CONSTANTS.FORM_NAME,
    REVIEW_PAGE_CONSTANTS.FORM_NAME,
  ],
};
export const FORM_VALIDATIONS: Record<
  string,
  Record<string, FormValidationType>
> = {
  [CARGO_STAGES.STAGE1]: {
    [BUSINESS_DETAILS_CONSTANTS.FORM_NAME]: cloneDeep(
      BusinessDetails.formValidation
    ),
    [SHIPMENT_DETAILS_CONSTANTS.FORM_NAME]: cloneDeep(
      ShipmentDetails.formValidation
    ),
    [INCIDENT_DETAILS_CONSTANTS.FORM_NAME]: cloneDeep(
      IncidentDetails.formValidation
    ),
  },
  [CARGO_STAGES.STAGE2]: {
    [CLAIM_DETAILS_CONSTANTS.FORM_NAME]: cloneDeep(ClaimDetails.formValidation),
  },
  [CARGO_STAGES.STAGE3]: {
    [FILE_ATTACHMENTS_CONSTANTS.FORM_NAME]: cloneDeep(
      FileAttachments.formValidation
    ),
  },
};
